@if (isVisible()) {
    <div class="lv-help-widget">
        @if (state.isIntern) {
            <a id="lv-help-widget-btn" class="lv-help-widget__button" [href]="helpUrl()" target="_blank">
                <span>{{ 'DOMAIN_STARTSCHERM.HEADER_WIDGET.HELP.TITLE_BTN' | i18n }}</span>
                <span class="lv-help-widget__button-icon fa fa-question"></span>
            </a>
        } @else {
            <button
                id="lv-help-widget-btn"
                class="lv-help-widget__button"
                type="button"
                aria-haspopup="true"
                [attr.aria-expanded]="state.showDialog().help"
                (click)="state.toggleDialog('help')"
            >
                <span>{{ 'DOMAIN_STARTSCHERM.HEADER_WIDGET.HELP.TITLE_BTN' | i18n }}</span>
                <span class="lv-help-widget__button-icon fa fa-question"></span>
            </button>

            <div
                baasClickOutside
                class="lv-header-widget__dialog"
                [class.lv-header-widget__dialog--open]="state.showDialog().help"
                (clickOutside)="state.toggleDialog('help')"
                [clickOutsideEnabled]="state.showDialog().help"
                exclude="#lv-help-widget-btn"
                aria-labelledby="lv-help-widget-btn"
            >
                <div class="lv-header-widget__header">
                    <div class="lv-header-widget__title">{{ 'DOMAIN_STARTSCHERM.HEADER_WIDGET.HELP.TITLE' | i18n }}</div>
                    <button matIconButton [disableRipple]="true" class="lv-header-widget__close" style="margin: 0.5rem" aria-label="Sluiten" (click)="state.toggleDialog('help')">
                        <mat-icon class="fa fa-times"></mat-icon>
                    </button>
                </div>
                <div class="lv-header-widget__content">
                    <p>{{ 'DOMAIN_STARTSCHERM.HEADER_WIDGET.HELP.CONTACT_DESCRIPTION' | i18n }}</p>
                    <ul class="lv-header-widget__list">
                        <li>
                            <a [href]="helpUrl()" target="_blank" class="lv-header-widget__list-item">
                                <span class="lv-header-widget__icon fa fa-info" aria-describedby="lv-widget-help-page"></span>
                                <span class="lv-header-widget__description" id="lv-widget-help-page">
                                    <span> {{ 'DOMAIN_STARTSCHERM.HEADER_WIDGET.HELP.HELP_PAGE' | i18n }} </span>
                                </span>
                            </a>
                        </li>
                        <li>
                            <a
                                (click)="openMailons()"
                                (keydown.enter)="openMailons()"
                                (keydown.space)="openMailons()"
                                class="lv-header-widget__list-item"
                                tabindex="0"
                            >
                                <span class="lv-header-widget__icon far fa-envelope" aria-describedby="lv-widget-mail"></span>
                                <span class="lv-header-widget__description" id="lv-widget-mail">
                                    <span> {{ 'DOMAIN_STARTSCHERM.HEADER_WIDGET.HELP.MAIL_US' | i18n }} </span>
                                </span>
                            </a>
                        </li>
                        <li>
                            <a [href]="contactUrl()" target="_blank" class="lv-header-widget__list-item">
                                <span class="lv-header-widget__icon fa fa-phone" aria-describedby="lv-widget-phone"></span>
                                <span class="lv-header-widget__description" id="lv-widget-phone">
                                    <span> {{ 'DOMAIN_STARTSCHERM.HEADER_WIDGET.HELP.CALL_US' | i18n }} </span>
                                </span>
                            </a>
                        </li>
                    </ul>
                </div>
                @if (clientNumber()) {
                    <div class="lv-header-widget__footer">
                        <span class="lv-header-widget__icon fa fa-exclamation-triangle" aria-describedby="lv-widget-client-number-footer"></span>
                        <span class="lv-header-widget__description" id="lv-widget-client-number-footer">
                            <span>
                                {{ 'DOMAIN_STARTSCHERM.HEADER_WIDGET.HELP.CLIENT_NUMBER_NOTIFICATION' | i18n }}
                                <b class="text-nowrap">{{ parsedClientNumber() }}</b>
                            </span>
                        </span>
                    </div>
                }
            </div>
        }
    </div>
}
